// extracted by mini-css-extract-plugin
export default {"video_player":"_3A_2Z","videoPlayer":"_3A_2Z","video_container":"_2vLYQ","videoContainer":"_2vLYQ"};